import BaseCtrl from 'edge/platform/base/BaseCtrl';
import {getConfigValue} from 'gw-portals-config';
import appFeatures from 'effective-features!';

const fn = ($scope, $stateParams, $state) => {
    const ctrl = Object.create(BaseCtrl);

    ctrl.init = () => {
        $scope.phoneNumber = getConfigValue('appSettings.supportPhone');
        $scope.uwIssues = $stateParams.uwIssues;
        $scope.gatewayQuote = appFeatures.gatewayquoteandbind === 'true';
    };

    ctrl.goBackToHomeState = () => {
        const [returnState, params] = $stateParams.returnStateInfo;
        $state.go(returnState, params);
    };

    return ctrl.create($scope);
};
fn.$inject = ['$scope', '$stateParams', '$state'];

export default fn;
